// tslint:disable:no-any
// tslint:disable:no-string-literal

import React, { Component } from 'react';
import DivesFilterTable from '../components/DivesFilterTable';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { DisplayDateTime, DisplayDepth } from '../components/Display';
import DiveRemoveModal from '../components/DiveRemoveModal';
import Message from '../components/Message';
import { isUniqueMessage } from '../components/Messages';
import { DiveService } from '../services/DiveService';

export interface IDivesTableProps {
    dives: any;
    shared: boolean;
    refreshDives: () => void;
    title: string;
    filtering?: any;
    sourceData?: any;
    viewDetail: any;
    editDive?: any;
    year?: any;
}

interface IDivesTableState {
    showFilterRow: boolean;
    pageCount: number;
    recordsOnPage: number;
    year: any;
    filter: any;
    removeId: any;
    sourceData: any;
    data: any;
    shared: boolean;
    offset: number;
    sort: string;
    sortDirection: string;
    messages: any;
}

class DivesTable extends Component<IDivesTableProps, IDivesTableState> {
    public static defaultProps: Partial<IDivesTableProps> = {
        filtering: true
    };

    constructor(props: IDivesTableProps) {
        super(props);

        this.state = {
            showFilterRow: false,
            pageCount: 0,
            recordsOnPage: 10,
            year: null,
            filter: null,
            removeId: null,
            sourceData: props.dives,
            data: props.dives,
            shared: props.shared,
            offset: 0,
            sort: 'startDate',
            sortDirection: 'desc',
            messages: []
        };
    }

    componentDidMount() {
        this.sortData();
    }

    componentWillReceiveProps(nextProps: IDivesTableProps) {
        this.setState(
            {
                year: nextProps.year === undefined ? null : nextProps.year,
                sourceData: [...nextProps.dives],
                data: [...nextProps.dives]
            },
            () => {
                this.sortData();
            }
        );
    }

    addMessage(text: string, type: string = 'info', autoClose: boolean = true) {
        if (isUniqueMessage(text, this.state.messages)) {
            var newMessages = [...this.state.messages];
            newMessages.push({
                text: text,
                type: type,
                autoClose: autoClose
            });

            this.setState({ messages: newMessages });
        }
    }

    onMessageClose() {
        this.setState({
            messages: []
        });
    }

    handleToggleSearchBox() {
        var showFilterRow = this.state.showFilterRow === false ? true : false;
        this.setState(
            {
                showFilterRow: showFilterRow
            },
            () => {
                // vycisteni filtru
                if (!showFilterRow) {
                    this.handleFind(null);
                }
            }
        );
    }

    acceptFilter(diveData: any) {
        if (this.state.filter === null) {
            return true;
        }

        // negace filtru
        // pokud udaj ponoru nevyhovuje, funkce vraci false

        // min ponor
        if (this.state.filter.depthFrom !== undefined) {
            if (diveData.maxDepth <= parseFloat(this.state.filter.depthFrom)) {
                return false;
            }
        }
        // max ponor
        if (this.state.filter.depthTo !== undefined) {
            if (diveData.maxDepth >= parseFloat(this.state.filter.depthTo)) {
                return false;
            }
        }
        // min datum
        if (this.state.filter.dateFrom !== undefined) {
            if (diveData.startDate <= this.state.filter.dateFrom) {
                return false;
            }
        }

        // max datum
        if (this.state.filter.dateTo !== undefined) {
            if (diveData.startDate >= this.state.filter.dateTo) {
                return false;
            }
        }
        // lokalita
        if (this.state.filter.location !== undefined) {
            let tempString = diveData.location;
            if (diveData.location === null || diveData.location === undefined) {
                return false;
            }
            if (
                tempString
                    .toLowerCase()
                    .indexOf(this.state.filter.location.toLowerCase()) === -1
            ) {
                return false;
            }
        }

        return true;
    }

    filterData(data: any) {
        // filtrace
        var index = data.length;
        while (index--) {
            var row = data[index];

            var dateStart = new Date(row.startDate);
            if (
                (dateStart.getFullYear() !== this.state.year &&
                    this.state.year !== null) ||
                !this.acceptFilter(row)
            ) {
                data.splice(index, 1);
            }
        }

        return data;
    }

    setSort(sort: any) {
        var newSortDirection =
            this.state.sort === sort
                ? this.state.sortDirection === 'desc' ? 'asc' : 'desc'
                : 'desc';

        this.setState(
            {
                sort: sort,
                sortDirection: newSortDirection
            },
            () => {
                this.sortData();
            }
        );
    }

    sortData() {
        // nastavim nejprve rok
        var newData = this.filterData([...this.state.sourceData]);
        this.setState(
            {
                data: newData
            },
            () => {
                var tempNewData: any = [...this.state.data];
                var newPageCount = this.state.pageCount;
                var sortField = this.state.sort;
                var sortDirection = this.state.sortDirection;

                if (Array.isArray(tempNewData) && tempNewData.length > 0) {
                    tempNewData.sort((a, b) => {
                        const aValue = sortField === 'startDate' ? Date.parse(a[sortField]) : a[sortField];
                        const bValue = sortField === 'startDate' ? Date.parse(b[sortField]) : b[sortField];

                        if (aValue === bValue) {
                            return 0;
                        }
                        if (sortDirection === 'asc') {
                            return aValue > bValue ? 1 : -1;
                        } else {
                            return aValue < bValue ? 1 : -1;
                        }
                    });
                }

                if (tempNewData !== undefined) {
                    var computePageCount = Math.ceil(
                        tempNewData.length / this.state.recordsOnPage
                    );
                    if (computePageCount !== newPageCount) {
                        newPageCount = computePageCount;
                    }
                }

                this.setState({
                    data: tempNewData,
                    pageCount: newPageCount
                });
            }
        );
    }

    handlePageClick(e: any) {
        this.setState({
            offset: e.selected
        });
    }

    handleFind(filter: any) {
        this.setState(
            {
                filter: filter,
                offset: 0
            },
            () => {
                this.sortData();
            }
        );
    }

    onClickRemoveDive(e: any, diveId: any) {
        this.setState({
            removeId: diveId
        });
    }

    hideRemoveModal() {
        this.setState({
            removeId: null
        });
    }

    async handleRemoveDive() {
        let response: Response | undefined;

        if (this.state.shared) {
            response = await DiveService.getInstance().removeSharedDiveByDiveId(this.state.removeId);
        } else {
            response = await DiveService.getInstance().removeDiveByDiveId(this.state.removeId);
        }
        if (response == undefined) {
            return;
        }

        switch (response.status) {
            case 500:
                this.addMessage('Unknown error', 'error');
                break;
            case 404:
                this.addMessage('Dive not found', 'error');
                break;
            case 200:
                this.addMessage('Dive deleted', 'success');
                this.props.refreshDives();
                break;
            default:
                break;
        }

        this.setState({
            removeId: null
        });
    }

    render() {
        // const { viewDetail } = this.props;

        var recordsFrom = this.state.offset * this.state.recordsOnPage;
        var recordsTo = recordsFrom + this.state.recordsOnPage - 1;

        return (
            <section>
                <DiveRemoveModal
                    display={this.state.removeId !== null}
                    hideModal={() => this.hideRemoveModal()}
                    modalConfirm={() => this.handleRemoveDive()}
                />

                {this.state.messages.length > 0 && (
                    <div className="messages">
                        {this.state.messages.map((message: any, index: any) => {
                            return (
                                <Message
                                    key={index}
                                    type={message.type}
                                    text={message.text}
                                    autoClose={message.autoClose}
                                    onClose={() => this.onMessageClose()}
                                />
                            );
                        })}
                    </div>
                )}

                <table className="standardTable dashboard__table activeRows">
                    <caption className="first">
                        <h3>{this.props.title}</h3>
                        {this.props.filtering !== false &&
                            this.state.sourceData.length > 0 && (
                                <button
                                    className="btn btn--xsmallpill btn--colorRed"
                                    onClick={() => this.handleToggleSearchBox()}
                                >
                                    Filter
                                </button>
                            )}
                    </caption>
                    <thead>
                        {this.props.filtering !== false &&
                            this.state.sourceData.length > 0 && (
                                <tr
                                    className={
                                        'filterRow' +
                                        (this.state.showFilterRow === true
                                            ? ' display'
                                            : '')
                                    }
                                >
                                    <th colSpan={6}>
                                        <DivesFilterTable
                                            handleFind={filter =>
                                                this.handleFind(filter)
                                            }
                                        />
                                    </th>
                                </tr>
                            )}
                        <tr>
                            <th style={{ width: '10%' }} className="xs-hidden">
                                <span
                                    className={
                                        'sort' +
                                        (this.state.sort === 'serial'
                                            ? ' current ' +
                                            this.state.sortDirection
                                            : '')
                                    }
                                    onClick={() => this.setSort('serial')}
                                >
                                    Serial
                                </span>
                            </th>
                            <th style={{ width: '22%' }}>
                                <span
                                    className={
                                        'sort' +
                                        (this.state.sort === 'startDate'
                                            ? ' current ' +
                                            this.state.sortDirection
                                            : '')
                                    }
                                    onClick={() => this.setSort('startDate')}
                                >
                                    Start date
                                </span>
                            </th>
                            <th>
                                <span
                                    className={
                                        'sort' +
                                        (this.state.sort === 'location'
                                            ? ' current ' +
                                            this.state.sortDirection
                                            : '')
                                    }
                                    onClick={() => this.setSort('location')}
                                >
                                    Locality
                                </span>
                            </th>
                            <th style={{ width: '17%' }}>
                                <span
                                    className={
                                        'sort' +
                                        (this.state.sort === 'maxDepth'
                                            ? ' current ' +
                                            this.state.sortDirection
                                            : '')
                                    }
                                    onClick={() => this.setSort('maxDepth')}
                                >
                                    Max. depth
                                </span>
                            </th>
                            <th style={{ width: '15%' }} className="xs-hidden">
                                <span
                                    className={
                                        'sort' +
                                        (this.state.sort === 'duration'
                                            ? ' current ' +
                                            this.state.sortDirection
                                            : '')
                                    }
                                    onClick={() => this.setSort('duration')}
                                >
                                    Duration
                                </span>
                            </th>
                            <th className="xs-hidden" />
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.data !== undefined &&
                            this.state.data.map((dive: any, index: number) => {
                                if (
                                    index >= recordsFrom &&
                                    index <= recordsTo
                                ) {
                                    return (
                                        <tr
                                            key={dive['id']}
                                            onClick={() =>
                                                this.props.viewDetail(dive['id'])
                                            }
                                        >
                                            <td className="xs-hidden">
                                                {dive['serial']}
                                            </td>
                                            <td>
                                                <DisplayDateTime
                                                    data={dive['startDate']}
                                                />
                                            </td>
                                            <td>{dive['location']}</td>
                                            <td>
                                                <DisplayDepth
                                                    data={dive['maxDepth']}
                                                />
                                            </td>
                                            <td className="xs-hidden">
                                                {dive['duration']}
                                            </td>
                                            <td className="xs-hidden standardTable__icons">
                                                <div
                                                    title="View dive detail"
                                                    className="standardTable__icons--rate standardTable__icons--item"
                                                    onClick={e => {
                                                        this.props.viewDetail(
                                                            dive['id']
                                                        );
                                                        e.stopPropagation();
                                                    }}
                                                />
                                                {this.state.shared !== true && (
                                                    <div
                                                        title="Edit dive"
                                                        // tslint:disable-next-line:max-line-length
                                                        className="standardTable__icons--edit standardTable__icons--item"
                                                        onClick={e => {
                                                            this.props.editDive(
                                                                dive['id']
                                                            );
                                                            e.stopPropagation();
                                                        }}
                                                    />
                                                )}
                                                <div
                                                    title="Delete dive"
                                                    className="standardTable__icons--trash standardTable__icons--item"
                                                    onClick={e => {
                                                        this.onClickRemoveDive(
                                                            e,
                                                            dive['id']
                                                        );
                                                        e.stopPropagation();
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                    </tbody>

                    {this.state.sourceData.length === 0 && (
                        <tfoot>
                            <tr>
                                <td colSpan={6} className="standardTable__info">
                                    {this.state.shared !== true && (
                                        <span>
                                            You have no dives yet.{' '}
                                            <Link
                                                to="/app/new-dive"
                                                style={{
                                                    color: '#ef4c36',
                                                    textDecoration: 'underline'
                                                }}
                                            >
                                                Start by uploading a dive!
                                            </Link>
                                        </span>
                                    )}
                                    {this.state.shared === true && (
                                        <span>
                                            No dive was shared with you yet.
                                        </span>
                                    )}
                                </td>
                            </tr>
                        </tfoot>
                    )}

                    {this.state.sourceData.length > 0 && (
                        <tfoot>
                            <tr>
                                <td
                                    colSpan={6}
                                    className="standardTable__pagination"
                                >
                                    {this.state.pageCount > 0 && (
                                        <ReactPaginate
                                            previousLabel={
                                                <span className="noSelect">
                                                    Previous
                                                </span>
                                            }
                                            nextLabel={
                                                <span className="noSelect">
                                                    Next
                                                </span>
                                            }
                                            breakLabel={'...'}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={(e: any) =>
                                                this.handlePageClick(e)
                                            }
                                            containerClassName={
                                                'pagination noSelect'
                                            }
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                        />
                                    )}
                                </td>
                            </tr>
                        </tfoot>
                    )}
                </table>
            </section>
        );
    }
}

export default DivesTable;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DivesTable.tsx